import { Component, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import * as lodash from 'lodash';

@Component({
  selector: 'app-status-badge',
  template: `<small><ng-content></ng-content></small>`,
  host: {
    style: 'min-width: 100px; font-size: 0.9375rem;',
    'class': 'd-inline-block rounded-sm px-2 fs-sm fw-semibold lh-base text-center text-uppercase'
  }
})
export class StatusBadgeComponent implements OnChanges {
  static ThemeMap = new Map<string, [string, string]>([
    ['primary', ['text-primary', 'bg-primary-subtle']],
    ['success', ['text-success', 'bg-success-subtle']],
    ['warning', ['text-warning', 'bg-warning-subtle']],
    ['danger', ['text-danger', 'bg-danger-subtle']],
    ['info', ['text-info', 'bg-info-subtle']],
    ['secondary', ['text-body-secondary', 'bg-body-secondary']],
    ['purple', ['text-purple', 'bg-purple-subtle']],
  ]);

  @Input() color: string;

  constructor(private renderer: Renderer2, private elementRef: ElementRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.color && changes.color.currentValue !== changes.color.previousValue) {
      const renderer = this.renderer;
      const hostElement = this.elementRef.nativeElement;

      lodash.flattenDeep(Array.from(StatusBadgeComponent.ThemeMap.values())).forEach((item): void => {
        renderer.removeClass(hostElement, item);
      });
      if (StatusBadgeComponent.ThemeMap.has(changes.color.currentValue)) {
        StatusBadgeComponent.ThemeMap.get(changes.color.currentValue).forEach((item): void => {
          renderer.addClass(hostElement, item);
        });
      }
    }
  }
}
